import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var Card = function Card(_a) {
  var className = _a.className,
    children = _a.children,
    active = _a.active;
  var cssClasses = classNames(["rounded-base", "border-2", "border-light"], className);
  return /*#__PURE__*/React.createElement("div", {
    "data-test-role": "card",
    className: cssClasses,
    style: getStyles(active)
  }, children);
};
function getStyles(active) {
  return active ? {
    background: "linear-gradient(102.27deg, rgba(8, 103, 214, 0.05) 0%, rgba(110, 90, 161, 0.05) 100%)"
  } : {};
}
Card.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.bool
};

export { Card };
//# sourceMappingURL=index.es.js.map
